import LeaveRule from '@/api/hr/leave-rule'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employeeTypes: [],
  leaveTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_EMPLOYEE_TYPES(state, data) {
    state.employeeTypes = data
  },

  SET_LEAVE_TYPES(state, data) {
    state.leaveTypes = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_year: context.state.cycle_year,
        cycle_month: context.state.cycle_month
      },
      attributes
    )
    return LeaveRule.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return LeaveRule.store(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.employeeTypes.length > 0) {
      let response = await LeaveRule.employeeType()
      context.commit('SET_EMPLOYEE_TYPES', response.data)
    }
    if (!context.state.leaveTypes.length > 0) {
      let response = await LeaveRule.leaveType()
      context.commit('SET_LEAVE_TYPES', response.data)
    }
  }
}
